export default class Settings {
  constructor() {
    this.showPasswordContent();
    this.createExportButton();
  }

  showPasswordContent() {
    const field = document.querySelector("#vindi-pagamentos-token");
    if (field) {
      field.addEventListener("focusin", () => {
        field.setAttribute("type", "text");
      });

      field.addEventListener("focusout", () => {
        field.setAttribute("type", "password");
      });
    }
  }

  createExportButton() {
    const anchor = document.querySelector("#vindi-pagamentos-token");

    if (anchor) {
      const button = document.createElement("a");
      button.setAttribute("id", "wvp-export-btn");
      button.classList.add("wvp-export-btn", "woocommerce-save-button", "components-button", "is-secondary");
      button.innerText = "Exportar Configurações";

      const form = document.querySelector("#mainform > .submit");
      form.appendChild(button);

      this.exportSettings(button);
    }
  }

  exportSettings(button) {
    button.addEventListener("click", () => {
      this.getSettingsContent();
    });
  }

  getSettingsContent() {
    const body = new FormData();
    body.append("action", "export_settings");

    fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
      method: "POST",
      body: body,
    })
      .then((response) => response.json())
      .then((data) => {
        this.downloadSettingsFile(JSON.stringify(data.content, null, 4));

        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
  }

  downloadSettingsFile(content) {
    const file = new File([content], "settings.json", {
      type: "application/json",
    });

    const url = URL.createObjectURL(file);
    const element = document.createElement("a");

    if (element) {
      element.setAttribute("href", url);
      element.setAttribute("download", "settings.json");

      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  }
}
